import React from 'react';
import { useTranslation } from 'react-i18next';

import Layout from 'components/Layout';
import DailyCard from 'components/DailyCard';
import Logo from 'components/Logo';

function HomeScreen() {
  const { t } = useTranslation();

  return (
    <Layout>
      <div className="home-screen-wrapper">
        <div className="game-icon">
          <Logo size={50} />
        </div>
        <div className="game-title">Bokstavo</div>
        <div className="game-description">
          {t('homeScreen.gameDescription')}
        </div>
        <DailyCard />
      </div>
    </Layout>
  );
}

export default HomeScreen;
